<template>
  <div class="info-alert-dark">
    <v-alert
      border="left"
      colored-border
      type="info"
    >
      <div class="mb-2">Внимание! При установке ролей следует соблюдать порядок подчиненности.</div>
      <div class="mb-2">При наличии у пользователя нескольких ролей -  доступы к разделам и функциям будут предоставляться на основании роли с наименьшими приоритетами из выбранных в списке.</div>
      Подробнее о ролях и доступах - см.  в разделе "Доступы" в <a
        :class="$style.link"
        :href="user_guide_path"
        download
        target="_blank"
      >
        Руководстве пользователя
      </a>
    </v-alert>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { global_store } from '@/store';

@Component
export default class extends Vue {
  get user_guide_path() {
    return global_store.state.user_guide_path;
  }
}
</script>

<style module lang="scss">
@import "@/components/info-alert/info-alert.scss";
@import '@/scss/common/links.scss';
</style>
